interface Props {
    name: string;
    nameTooltip: string;
}

export const Tooltip = ({name, nameTooltip} : Props) => {
    return (
        <>
            <div className="tooltip">{name}
                <span className="tooltiptext">{nameTooltip}</span>
            </div>
        </>
    )
}